import { apiPost } from 'chipta-libs/api/utils.js';
/**
 * Send a contact message through the Chipta API
 *
 * The `data` argument should contain the following fields:
 *
 * - email
 * - name
 * - message
 */
export function sendContactMessage(data) {
  return apiPost('contact/', data);
}
